import Collaborators from './collaborators';

export default Collaborators;
